import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { newLineString } from '@ami/react/core';
import { QuoteProductDimension } from '../otherQuoteEntities';
import BuildToOrderLeadTimeLabel from '../../quotes/lead-times/BuildToOrderLeadTimeLabel';
import InventoryLeadTimeLabel from '../../quotes/lead-times/InventoryLeadTimeLabel';
import _ from 'lodash';
//import './ProductSelectionComponent.scss';
import { appConfig } from '@ami/react/core';
import { productGroupDimensionCategory } from '../../products/productGroupDimensionCategoryType';
import ThumbBucketLocationType from '../entities/thumbBucketLocationType';
import BucketBrandType from '../entities/bucketBrandType';

const LeadTimeImage = ({ name, imageUrl }) => (
  <Fragment>
    {imageUrl && (
      <img
        src={imageUrl}
        className="img-fluid"
        alt={name}
        style={{ marginRight: '3px' }}
      />
    )}
  </Fragment>
);

const SingleLineProductDimension = ({ value }) => {
  return <React.Fragment>{value}</React.Fragment>;
};

const MultiLineProductDimension = ({ value }) => {
  const items = value.split(newLineString).filter((x) => x);
  return (
    <ul className="text-start mb-0 clear-list-style">
      {items.map((x) => (
        <li key={x}>{x}</li>
      ))}
    </ul>
  );
};

const ProductDimension = ({ dimension, noBucketSpecsAvailable }) => {
  if (dimension.type !== 'MultiLine') {
    var value = dimension.value;
    if (
      dimension.category === productGroupDimensionCategory.Width &&
      noBucketSpecsAvailable
    ) {
      value = 'TBD';
    }
    return (
      <SingleLineProductDimension value={value} category={dimension.category} />
    );
  }

  if (dimension.type !== 'MultiLine')
    return <SingleLineProductDimension value={dimension.value} />;
  return <MultiLineProductDimension value={dimension.value} />;
};

const BuildToOrderOnlyProduct = ({
  productId,
  product,
  productDimensions,
  isForInventoryItemCreation,
  onProductSelected,
  noBucketSpecsAvailable,
  forceUseStandardLead
}) => {
  let leadTime = null;
  if (product.leadTime?.standard || product.leadTime?.fastTrack) {
    leadTime = forceUseStandardLead ? product.leadTime.standard : (product.leadTime.fastTrack ?? product.leadTime.standard);
  }

  return (
    <tr>
      {productDimensions.map((dimension) => (
        <td key={dimension.id} data-title={dimension.name}>
          <ProductDimension
            dimension={dimension}
            noBucketSpecsAvailable={noBucketSpecsAvailable}
          />
        </td>
      ))}
      <td data-title="Product Number">
        <div>{product.partNumber}</div>
        {appConfig.showDebugInfo && <div>{product.id}</div>}
      </td>

      {!isForInventoryItemCreation && (
        <td className="leadtime" data-title="Lead Time">
          {leadTime && (
            <LeadTimeImage
              name={leadTime.name}
              imageUrl={leadTime.imageUrl}
            />
          )}
          <BuildToOrderLeadTimeLabel
            leadTimeDays={leadTime?.numberOfDays}
          />
        </td>
      )}

      {isForInventoryItemCreation && (
        <td data-title="Weight Categories">
          <ul style={{ listStyle: 'none', paddingLeft: 0, marginBottom: 0 }}>
            {product.weightCategoryLabels.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </ul>
        </td>
      )}
      <td className="clearfix">
        <button
          type="button"
          className={`select-button btn ${product.id === productId ? 'btn-success' : 'btn-primary'
            } btn-sm`}
          onClick={() => onProductSelected(product.id)}
        >
          {product.id === productId ? 'Selected' : 'Select'}
        </button>
      </td>
    </tr>
  )
};

const Rows = ({
  productInventoryItems,
  productDimensions,
  product,
  productId,
  inventoryItemId,
  onProductSelected,
  forceUseStandardLead
}) => {
  let leadTime = null;
  if (product.leadTime?.standard || product.leadTime?.fastTrack) {
    leadTime = forceUseStandardLead ? product.leadTime.standard : (product.leadTime.fastTrack ?? product.leadTime.standard);
  }

  return (
    <Fragment>
      {_.sortBy(productInventoryItems, (x) => x.leadTime.numberOfDays).map(
        (x, idx) => (
          <tr key={idx} className="product-inventory-item">
            <td colSpan={productDimensions.length} className="details">
              {x.productOptions.map((option) => (
                <div key={option.productOptionId}>
                  {option.seriesName}
                  <br />
                  {option.partNumber} - {option.name}
                </div>
              ))}
              {x.paintColor && <div>Painted {x.paintColor}</div>}
              {x.notes && <div>{x.notes}</div>}
              {x.productOptions.length === 0 && !x.notes && (
                <div>No options specified</div>
              )}
              {x.isRestricted && (
                <span className="badge text-bg-danger mt-1 p-1">
                  {x.restrictedReason}
                </span>
              )}
              {x.isConsignment && <div className="alert alert-info text-start p-2 mb-0">
                Consignment <br />
                {x.consignmentDealerBranchName} <br />
                {x.defaultTerritoryManagerName}
              </div>}
            </td>
            <td className="inventory-item-stock-type">
              <span>
                {x.inStock ? 'In Stock' : 'Stock Run'} ({x.quantity})
              </span>
            </td>
            <td>
              <InventoryLeadTimeLabel leadTime={x.leadTime} />
            </td>
            <td>
              <button
                type="button"
                className={`select-button btn ${product.id === productId && inventoryItemId === x.id
                  ? 'btn-success'
                  : 'btn-primary'
                  } btn-sm`}
                onClick={() => onProductSelected(product.id, x.id)}
              >
                {product.id === productId && inventoryItemId === x.id
                  ? 'Selected'
                  : 'Select'}
              </button>
            </td>
          </tr>
        )
      )}
      <tr className="product-inventory-item">
        <td colSpan={productDimensions.length} className="details">
          <div>Build to Order</div>
        </td>
        <td></td>
        <td className="leadtime">
          {leadTime && (
            <LeadTimeImage
              name={leadTime.name}
              imageUrl={leadTime.imageUrl}
            />
          )}
          <BuildToOrderLeadTimeLabel
            leadTimeDays={leadTime?.numberOfDays}
          />
        </td>
        <td>
          <button
            type="button"
            className={`select-button btn ${product.id === productId && !inventoryItemId
              ? 'btn-success'
              : 'btn-primary'
              } btn-sm`}
            onClick={() => onProductSelected(product.id)}
          >
            {product.id === productId && !inventoryItemId ? 'Selected' : 'Select'}
          </button>
        </td>
      </tr>
    </Fragment>
  );
}

export default class ProductSelectionRowComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.productId === props.product.id,
    };
  }
  static propTypes = {
    onProductSelected: PropTypes.func.isRequired,
    productId: PropTypes.string,
    inventoryItemId: PropTypes.string,
    productGroup: PropTypes.instanceOf(Object),
    product: PropTypes.instanceOf(Object),
    inventoryItems: PropTypes.arrayOf(Object),
    isForInventoryItemCreation: PropTypes.bool,
    noBucketSpecsAvailable: PropTypes.bool,
    thumbBucketLocation: PropTypes.string,
    thumbExistingBucketBrand: PropTypes.string
  };

  getTopLevelLeadTime() {
    const {
      productId,
      inventoryItemId,
      product,
      productInventoryItems,
      thumbBucketLocation,
      thumbExistingBucketBrand
    } = this.props;
    const isAmiBucket = thumbBucketLocation === ThumbBucketLocationType.SameQuote || thumbBucketLocation === ThumbBucketLocationType.ExistingQuote && thumbExistingBucketBrand === BucketBrandType.ami.id;
    const forceUseStandardLead = !isAmiBucket && product.thumbForceStandardLeadTimeForNonAmiBucket;
    const leadTime = forceUseStandardLead ? product.leadTime.standard : (product.leadTime.fastTrack ?? product.leadTime.standard);

    if (productId !== product.id) {
      const bestInventoryItem = _.sortBy(
        productInventoryItems,
        (x) => x.leadTime.numberOfDays
      )[0];
      return <InventoryLeadTimeLabel leadTime={bestInventoryItem.leadTime} />;
    } else if (inventoryItemId) {
      return (
        <InventoryLeadTimeLabel
          leadTime={
            productInventoryItems.find((x) => x.id === inventoryItemId).leadTime
          }
        />
      );
    } else {
      return (
        <Fragment>
          <LeadTimeImage
            name={leadTime.name}
            imageUrl={leadTime.imageUrl}
          />
          <BuildToOrderLeadTimeLabel
            leadTimeDays={leadTime.numberOfDays}
          />
        </Fragment>
      );
    }
  }

  render() {
    const { isExpanded } = this.state;
    const {
      productId,
      inventoryItemId,
      product,
      productGroup,
      onProductSelected,
      productInventoryItems,
      isForInventoryItemCreation,
      noBucketSpecsAvailable,
      thumbBucketLocation,
      thumbExistingBucketBrand
    } = this.props;
    const productDimensions = QuoteProductDimension.getProductDimensions(
      productGroup,
      product
    );
    const isAmiBucket = thumbBucketLocation == ThumbBucketLocationType.SameQuote || thumbBucketLocation == ThumbBucketLocationType.ExistingQuote && thumbExistingBucketBrand === BucketBrandType.ami.id;
    const forceUseStandardLead = !isAmiBucket && product.thumbForceStandardLeadTimeForNonAmiBucket;

    if (productInventoryItems.length === 0) {
      return (
        <BuildToOrderOnlyProduct
          productId={productId}
          product={product}
          productDimensions={productDimensions}
          isForInventoryItemCreation={isForInventoryItemCreation}
          onProductSelected={onProductSelected}
          noBucketSpecsAvailable={noBucketSpecsAvailable}
          forceUseStandardLead={forceUseStandardLead}
        />
      );
    }
    return (
      <Fragment>
        <tr>
          {productDimensions.map((dimension) => (
            <td key={dimension.id} data-title={dimension.name}>
              <ProductDimension
                dimension={dimension}
                noBucketSpecsAvailable={noBucketSpecsAvailable}
              />
            </td>
          ))}
          <td data-title="Product Number">{product.partNumber}</td>
          <td className="leadtime" data-title="Best/Selected Lead Time">
            {!isExpanded && this.getTopLevelLeadTime()}
          </td>
          <td className="clearfix">
            <button
              type="button"
              className="btn btn-link p-0 mt-1"
              onClick={() => this.setState({ isExpanded: !isExpanded })}
            >
              {isExpanded ? 'hide' : 'view stock'}
            </button>
          </td>
        </tr>
        {isExpanded && (
          <Rows
            productInventoryItems={productInventoryItems}
            productDimensions={productDimensions}
            product={product}
            productId={productId}
            onProductSelected={onProductSelected}
            inventoryItemId={inventoryItemId}
            forceUseStandardLead={forceUseStandardLead}
          />
        )}
      </Fragment>
    );
  }
}
